export default "__VITE_ASSET__efed61c5__"